<template>
  <div>
    <!-- Button trigger modal -->
    <button @click.prevent="requestDataCandidate" type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal">
      Solicitar información
    </button>

    <!-- Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Solicitar información candidato</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div :class="typeMessage" role="alert" v-if="message != ''">
              {{message}}
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  export default {
    props: ['project'],
    data() {
      return {
        typeMessage: '',
        message: ''        
      }
    },
    methods: {
      setHeaders () {
        const token = document.querySelector('meta[name="csrf-token"]').getAttribute("content")
        axios.defaults.headers["x-csrf-token"] = token
        axios.defaults.headers.common["Accept"] = "application/json"
        axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"
      },
      async requestDataCandidate() {
        this.showMessage('Solicitando información candidato', 'alert-warning')
        const url = `/request_data_candidate?project_id=${this.project.id}`
        this.setHeaders()
        let request = await axios.get(url)
        if (request.status == 200) {
          this.showMessage('Información solicitada', 'alert-success')
          this.academic_reference = {}
        } else {
          this.showMessage('No se pudo solicitar la información', 'alert-danger')
        }
      },
      showMessage(message, typeMessage){
        this.message = message
        this.typeMessage = `alert ${typeMessage}`
        setTimeout(() => this.message = '', 3000)
      },              
    },
  }
</script>

<style lang="scss" scoped>

</style>